import gql from 'graphql-tag'

export const GET_RECRUITMENT = gql`
query EmployeeRecruitedAts {
  employeeRecruitedAts {
    isSuccessful
    message
    employeeRecruitedAts {
      companyId
      srcTable
      srcColumn
      hasRelation
      text
    }
  }
}`

export const RECRUITMENT_MUTATION_CREATE = gql`
mutation MutationType($input: CreateLookupInputSimple!) {
  createEmployeeRecruitedAt(input: $input) {
    isSuccessful
    message
    employeeRecruitedAt {
      companyId
      srcTable
      srcColumn
      hasRelation
      text
    }
  }
}`

export const RECRUITMENT_MUTATION_DELETE = gql`
mutation DeleteEmployeeRecruitedAt($input: DeleteLookupInputSimple!) {
  deleteEmployeeRecruitedAt(input: $input) {
    isSuccessful
    message
    employeeRecruitedAt {
      companyId
      srcTable
      srcColumn
      hasRelation
      text
    }
  }
}`

export const RECRUITMENT_MUTATION_UPDATE = gql`
mutation UpdateEmployeeRecruitedAt($input: UpdateLookupInputSimple!) {
  updateEmployeeRecruitedAt(input: $input) {
    isSuccessful
    message
    employeeRecruitedAt {
      companyId
      srcTable
      srcColumn
      hasRelation
      text
    }
  }
}`
